//** Component  */
import React from "react";
//** Lib */
import ManageRequests from "./RequestList";
import { securityKey } from "../../navigation/SecurityKey";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";


function RPARequest() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.RPAREQUESTOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.RPAREQUESTARCHIVETAB);

  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: <ManageRequests openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <ManageRequests openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <CustomTab data={data} />
  );
}

export default RPARequest;
